export default {
  body: '"Fantasque Sans Mono", "Helvetica Neue", "PingFang TC", "微軟正黑體", sans-serif',
  serif: '"Fantasque Sans Mono", "Helvetica Neue", "source-han-serif-tc", "PingFang TC", "微軟正黑體", serif',
};



// WEBPACK FOOTER //
// ./src/assets/fonts.js